<template>
    <div :id="attributes.value.location" class="basemap"></div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import debounce from 'lodash/debounce';

export default {
    name: "BaseMap",
    props: ['attributes'],
    data () {
        return {
            accessToken: 'pk.eyJ1IjoiY2hhY2hvcGF6b3MiLCJhIjoiY2pkMDN3eW4wNHkwZDJ5bGc0cnpueGNxbCJ9.WWWg_OnK5e7L1RknMliY4A',
            center: [103.811279, 1.345399],
            maxBounds: [
                [103.6, 1.1704753],
                [104.1, 1.4754753],
            ],
            zoom: 14
        }
    },
    computed: {
        lat (){
            return this.attributes.value.lat
        },
        long (){
            return this.attributes.value.long
        }
    },
    methods: {
        generateMap () {
            mapboxgl.accessToken = this.accessToken;

            const map = new mapboxgl.Map({
                container: this.attributes.value.location,
                style: "mapbox://styles/chachopazos/cisk2sggc004d2wnvjy0rxc8m",
                center: [this.long, this.lat],
                zoom: this.zoom,
                maxBounds: this.maxBounds,
                attributionControl: false
            })

            const marker = new mapboxgl.Marker()
                .setLngLat([this.long, this.lat])
                .addTo(map)
        },
        windowResize () {
            if (window.innerWidth > 768) {
                this.$el.querySelector('.map-locator').style.height = '100vh'
            } else {
                this.$el.querySelector('.map-locator').style.height = '50vh'
            }
            if (this.map) {
                this.map.resize()
            }
        }
    },
    mounted () {
        const self = this
        this.generateMap()
        window.addEventListener('resize', debounce(function () {
            self.windowResize()
        }, 100))
    }
}
</script>

<style lang="scss" scoped>
.basemap {
    height: 350px;
    max-width: 700px;

    a.mapboxgl-ctrl-logo {
        display: none;
    }
}
</style>